import { render, staticRenderFns } from "./JDictSelectTagZdy.vue?vue&type=template&id=19760cbe&scoped=true&"
import script from "./JDictSelectTagZdy.vue?vue&type=script&lang=js&"
export * from "./JDictSelectTagZdy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19760cbe",
  null
  
)

export default component.exports